const base = `${process.env.REACT_APP_BACKEND_URL}`;
const endpoints = {
  add_claim: `${base}/claim/`,
  get_all_claims: `${base}/claim/`,
  update_claim: `${base}/claim/update_status`,
  get_all_claimed_points: `${base}/points/claimed_points`,
};

export default endpoints;
